<template>
  <div class="top">
    <div class="title">
      <div>{{title}}</div>
      <div class="badge" v-if="todoNumber !== 0 && title === '我的待办'" style="display: flex;align-items: center;justify-content: center">{{todoNumber}}</div>
    </div>
    <div class="user">
      <div class="name">{{name}}</div>
<!--      <van-image-->
<!--          round-->
<!--          width="50px"-->
<!--          height="50px"-->
<!--          fit="cover"-->
<!--          src="https://img01.yzcdn.cn/vant/cat.jpeg"-->
<!--      />-->
    </div>
  </div>
</template>

<script>
export default {
  name: "topInfo",
  props: {
    title: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    todoNumber: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style scoped>
.top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 40px;
  background-color: #fff;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 998;
}

.title {
  margin-left: 10px;
  line-height: 100%;
  display: flex;
  align-items: center;
}

.user {
  display: flex;
  align-items: center;
  margin-right: 10px;
}

.name {
  margin-right: 10px;
}
.badge {
  width: 30px;
  height: 15px;
  background-color: #ee0a24;
  color: #FFFFFF;
  font-size: 12px;
  text-align: center;
  line-height: 15px;
  border-radius: 15px;
  margin-left: 5px;
}
</style>